/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_736a4d99","_736a4d99",""]'><cube-button-group direction="horizontal" :class='["","_736a4d99",""]'><cube-button :class='["btn-item","_736a4d99",""]'>取消按钮</cube-button><cube-button primary :class='["btn-item","_736a4d99",""]'>确认按钮</cube-button></cube-button-group></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_736a4d99"}'>
.btn-item
  flex: 1
  margin-bottom 15px
  &:last-child
    margin-left: 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_736a4d99"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_736a4d99"}
  /** script content **/
  require("./button-group-two.mpx.js?isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./button-group-two.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbutton-group-two736a4d99%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_736a4d99"],
    ctorType: "component",
    outputPath: "components/button-group-two736a4d99/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>